import React, { useEffect } from "react";
import { NavItemDataDataModel, NavItemModel } from "@models/layout";
import { Variants, motion } from "framer-motion";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import Accordian from "@components/common/Accordian";
import Link from "@components/common/Link";
import { twMerge } from "tailwind-merge";
import { isEmpty } from "@utils/common";

export interface NavItemPropsModel {
  key: string | number;
  navAttributes: NavItemModel;
  selectedSubMenu: string;
  setSelectedSubMenu: React.Dispatch<React.SetStateAction<string>>;
  setShowMenu: React.Dispatch<React.SetStateAction<boolean>>;
  isMenuOpen: boolean;
}

const listVariant: Variants = {
  close: {
    opacity: 0,
  },
  open: {
    opacity: 1,
  },
};
export const MobileNavItem: React.FunctionComponent<NavItemPropsModel> = ({
  navAttributes,
  selectedSubMenu,
  setSelectedSubMenu,
  setShowMenu,
  isMenuOpen,
}) => {
  const {
    title,
    children,
    type_of_menu: typeOfMenu,
    url = "/",
  } = navAttributes ?? {};
  const { data: childrenData } = children ?? {};

  useEffect(() => {
    if (!isMenuOpen) {
      setSelectedSubMenu("");
    }
  }, [isMenuOpen]);

  const handleAccordianClick = () => {
    if (childrenData?.length === 0) {
      setSelectedSubMenu("");
      setShowMenu(false);
    } else {
      if (selectedSubMenu === title) {
        setSelectedSubMenu("");
      } else {
        setSelectedSubMenu(title);
      }
    }
  };

  const renderHeader = () => {
    if (childrenData?.length === 0) {
      return (
        <span>
          <Link
            href={url}
            linkText={title}
            className="text-sm font-semibold"
            style={{
              // fontSize: "inherit",
              color: "#291E30",
              textDecoration: "none",
            }}
          />
        </span>
      );
    }
    return (
      <span className="text-sm" style={{ color: "#291E30" }}>
        {title}
      </span>
    );
  };
  const recurrsiveRendering = (
    dataObj: NavItemDataDataModel,
    depth: number,
    blockStyling: boolean = false
  ) => {
    if (!dataObj || isEmpty(dataObj)) return <></>;
    const { id, attributes } = dataObj;
    if (isEmpty(attributes)) return <></>;
    const {
      title,
      children,
      border_bottom: borderBottom,
      border_left: borderLeft,
    } = attributes;
    const borderLeftClassName = borderLeft ? "border-l border-grey-12" : "";
    const borderBottomClassName = borderBottom ? "border-b border-grey-12" : "";

    let additionalStyles: string = "";
    if (blockStyling) {
      if (depth === 0 || depth === 1) {
        additionalStyles = "text-dark-purple-50";
      }
    }
    const dynamicClassName = twMerge(
      "py-1 min-w-[140px] text-sm",
      borderLeftClassName,
      borderBottomClassName
    );

    if (children?.data?.length > 0) {
      return (
        <div
          style={{
            paddingLeft: `${6 * depth}px`,
            fontWeight: 530 - 20 * depth,
          }}
          key={id}
          className={dynamicClassName}
        >
          <div
            className={twMerge("pb-2 text-dark-purple-50", additionalStyles)}
            style={{ color: "#291E30" }}
          >
            {title}
          </div>
          {children.data.map((child) => {
            return (
              <div key={`${depth}_${child.id}`}>
                {recurrsiveRendering(child, depth + 1, blockStyling)}
              </div>
            );
          })}
        </div>
      );
    }
    return (
      <div
        className={dynamicClassName}
        style={{ paddingLeft: `${depth * 6}px`, fontWeight: 400 }}
        key={id}
        onClick={() => {
          setShowMenu(false);
        }}
      >
        <Link
          href={attributes.url}
          linkText={title}
          className="hover:font-normal text-dark-purple-50"
          style={{
            textDecoration: "none",
          }}
        />
      </div>
    );
  };
  const renderFlatMenu = () => {
    return (
      <motion.div
        className="!bg-white overflow-hidden z-50 flex text-dark-purple-50 my-3"
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <motion.div className=" bg-white">
          {childrenData.map((child) => {
            return recurrsiveRendering(child, 0, false);
          })}
        </motion.div>
      </motion.div>
    );
  };

  const renderChildOfBlockedMenu = () => {
    return (
      <div>
        {childrenData.map((cData) => {
          return (
            <div key={cData?.id} className="my-3">
              <div
                className="text-sm font-semibold pb-3"
                style={{ color: "#291E30" }}
              >
                {cData.attributes.title}
              </div>
              <div>
                {cData.attributes.children.data.map((child) => {
                  return recurrsiveRendering(child, 0, true);
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  const renderChildren = () => {
    if (typeOfMenu === "flat") {
      return renderFlatMenu();
    } else if (typeOfMenu === "blocked") {
      return renderChildOfBlockedMenu();
    }
    return renderFlatMenu();
  };

  return (
    <motion.li
      variants={listVariant}
      className="pt-6 pb-3 border-b flex items-center"
    >
      <Accordian
        handleClick={handleAccordianClick}
        isOpen={title === selectedSubMenu}
        header={renderHeader()}
        body={renderChildren()}
        wrapperClassName="border-none py-0"
        headerClassName="text-base text-dark-purple-50 justify-start items-center"
        closeIcon={FiChevronUp}
        openIcon={FiChevronDown}
        hideIcon={!childrenData?.length}
      />
    </motion.li>
  );
};

export default MobileNavItem;
